import { render } from "./alert.vue?vue&type=template&id=e59c2a98&scoped=true&ts=true"
import script from "./alert.vue?vue&type=script&lang=ts"
export * from "./alert.vue?vue&type=script&lang=ts"

import "./alert.vue?vue&type=style&index=0&id=e59c2a98&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59c2a98"]])

export default __exports__